import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import PlatformCostSummaryCostTypesEnum from '../../../Enums/PlatformCostSummaryCostTypesEnum';

export default class TpPlatformInvoiceCostSummarySearchParams extends SearchParamsBase {
  initialize() {
    // Preset by TpPlatformInvoiceCostSummaryTab; the backend filters the frozen summary rows
    // to this invoice (provenance source + platform invoice id) and, on the typed sub-tabs,
    // to one cost type. All three are SCOPE, not user filters.
    this.ThirdPartySource = '';
    this.ThirdPartyInvoiceId = '';
    this.CostType = '';
    // User filters.
    this.SelectedOfficeIds = [];
    this.SelectedCaspianClientIds = [];
    this.FilterCostType = '';
    this.CountsMismatch = '';
  }

  ClearAll() {
    // Deliberately keeps all three fields — the embedded grid is always scoped to one invoice.
  }

  static fieldsInSearchBox = [
    {
      fieldName: 'SelectedOfficeIds',
      label: 'Office',
      className: 'col-6',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
    },
    {
      fieldName: 'SelectedCaspianClientIds',
      label: 'Caspian Client',
      className: 'col-6',
      type: InputTypesEnum.ClientMultiChoice,
    },
    {
      // Separate from the CostType scope field so the descriptor cannot hide itself once used;
      // `hide` reads only the scope field, which users never write.
      fieldName: 'FilterCostType',
      label: 'Cost Type',
      className: 'col-6',
      type: InputTypesEnum.Select,
      options: TpPlatformInvoiceCostSummarySearchParams.getCostTypeOptions(),
      hide: (searchItem) => !!searchItem.CostType,
    },
    {
      fieldName: 'CountsMismatch',
      label: 'Counts Mismatch?',
      className: 'col-6',
      type: InputTypesEnum.EmptyYesNoSelect,
      tooltipText: 'Yes shows only rows where the Bravo shop count differs from the platform shop count.',
    },
  ];

  static title = 'Search in Summarized Invoice Items';
  static iconName = 'fa-solid fa-search';
  static saveType = 'TpPlatformInvoiceCostSummarySearchParams';

  static isThereAnySearchParameter() {
    return false;
  }

  static getCostTypeOptions() {
    return [
      { label: 'Choose one...', value: '', disabled: false },
      ...Object.values(PlatformCostSummaryCostTypesEnum).map((costType) => ({
        label: costType,
        value: costType,
        disabled: false,
      })),
    ];
  }
}
